export function downloadUrlParser(data: {
  path: any
  filename: any
  originalname: any
  mimetype: any
}) {
  let path = ""
  path += "&path=" + data.path
  path += "&filename=" + data.filename
  path += "&originalname=" + data.originalname
  path += "&mimetype=" + data.mimetype
  return import.meta.env["VITE_APP_API"] + "/download-file?" + path
}


export function parsePhoneNumber(phoneNumber: string) {
  if (!phoneNumber) return phoneNumber

  // Remove all spaces and special characters (keep only digits)
  let phone = phoneNumber.replace(/\D/g, "")

  // Remove leading zeros
  if (phone.startsWith("0")) {
    phone = phone.slice(1)
  }

  // If already starts with country code
  if (phone.startsWith("251")) {
    phone = phone.slice(3)
  }

  // Ensure the number is 9 digits (Ethiopian mobile)
  if (phone.length === 9) {
    return `+251${phone}`
  }

  // If already in correct format
  if (phoneNumber.startsWith("+251") && phone.length === 12) {
    return `+251${phone.slice(3)}`
  }

  // Fallback: return as is
  return phoneNumber
}
